/* Flag Linked Products — defensive dropdown redirect.
 * Swatches are real <a> tags and need no JS.
 */
(function () {
  'use strict';

  function bindSelect(select) {
    if (!select || select.dataset.flagLinkedBound === '1') return;
    select.dataset.flagLinkedBound = '1';

    select.addEventListener('change', function (event) {
      var url = event.target && event.target.value;
      if (!url) return;
      // Same-origin or relative URL only. Avoid open redirect surface.
      try {
        var current = window.location.href;
        var target = new URL(url, current);
        if (target.origin !== window.location.origin) return;
        window.location.href = target.href;
      } catch (_) {
        // Fallback: trust Liquid-emitted relative URL.
        window.location.href = url;
      }
    });
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var selects = scope.querySelectorAll('[data-flag-linked-select]');
    for (var i = 0; i < selects.length; i++) bindSelect(selects[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  // Re-bind after Shopify section rerenders in the theme editor.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
